const dateToDateString = (
  date: any,
  shortMonth = false,
  time = false,
  locale = "id"
) => {
  if (!date) return "";
  const d = new Date(date);
  const intlLocale =
    locale === "id"
      ? "id-ID"
      : locale === "en" || !locale
      ? "en-US"
      : `en-${String(locale).toUpperCase()}`;
  const options: Intl.DateTimeFormatOptions = {
    day: "2-digit",
    month: shortMonth ? "short" : "long",
    year: "numeric",
    ...(time && { hour: "2-digit", minute: "2-digit" })
  };
  return new Intl.DateTimeFormat(intlLocale, options).format(d);
};
export default dateToDateString;
